/**
 * The scheme ID URI for thumbnail tiles in DASH.
 *
 * @group DASH
 *
 * @beta
 */
export const THUMBNAIL_TILE_SCHEME_ID_URI = 'http://dashif.org/guidelines/thumbnail_tile';
//# sourceMappingURL=THUMBNAIL_TILE_SCHEME_ID_URI.js.map